import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate, useLocation } from "react-router-dom";

import { fetchOrderHistory } from "../redux/orderDetailSlice";
import API from "../../../../app/api";

import Breadcrumbs from "../../../../components/Breadcrumbs/Breadcrumbs";
import Footer from "../../../../components/Footer/Footer";

import OrderInfo from "../components/OrderDetailPage/OrderInfo";
import OrderItems from "../components/OrderDetailPage/OrderItems";
import PriceDetails from "../components/OrderDetailPage/PriceDetails";
import Timeline from "../components/OrderDetailPage/Timeline";
import CancelOrderModal from "../components/OrderDetailPage/CancelOrderModal";
import CancelOrderSection from "../components/OrderDetailPage/CancelOrderSection";
import ReturnExchangeButtons from "../components/OrderDetailPage/ReturnExchangeButtons";

  const OrderDetailPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { orderNo: order_no } = useParams();
  const { results, loading, error } = useSelector((state) => state.orders);
  const order = results?.[0];
  const [trackingData, setTrackingData] = useState([]);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const cancelledFromPage = location?.state?.cancelled === true;

  useEffect(() => {
    document.title = `Order Details: ${order_no}`;

    if (order_no) {
      dispatch(fetchOrderHistory({ order_no }));
      fetchTracking(order_no);
    }
  }, [dispatch, order_no]);

  const fetchTracking = async (orderNo) => {
    try 
    {
      const res = await API.get(`/account/orders/${orderNo}/tracking`);
      const raw = res?.data?.data?.tracking_history?.[0]?.activities || "{}";
      const parsed = JSON.parse(raw);
      const history = parsed?.data?.history || [];
      const base = [
        { label: "Order Placed", time: null, status: "done", type: "major" },
      ];
      const dynamic = history.map((item, idx) => ({
        id: idx,
        label: `${item.message} ${item.location ?? ""}`,
        time: new Date(item.event_time).toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        }),
        status: "done",
        type: "minor",
      }));

      setTrackingData([...base, ...dynamic]);

    } catch (err) {
      console.error("Tracking fetch failed:", err);
    }
  };

  if (loading) return <p>Loading order details...</p>;
  if (error) return <p style={{ color: "red" }}>Error loading order.</p>;
  if (!order) return <p>No order found.</p>;

  const breadcrumbPaths = [
    { label: "Orders", to: "/accounts/orders" },
    { label: order_no },
  ];

  return (
    <>
      <Breadcrumbs paths={breadcrumbPaths} />

      <div className="order-tracking-container order-traking-container">
        <div className="order-left">
          <OrderInfo order={order} orderNo={order_no} />
          <OrderItems items={order.order_items} />

          <PriceDetails
            order={order}
            totalAmount={order?.total_amount}
          />

          <CancelOrderSection
            order={order}
            orderNo={order_no}
            cancelledFromPage={cancelledFromPage}
            openModal={() => setShowCancelModal(true)}
          />
          <ReturnExchangeButtons
            order={order}
            orderNo={order_no}
          />
        </div>

        <div className="order-right">
          <div className="Order-right-box">
            <Timeline trackingData={trackingData} />
          </div>
        </div>

      </div>

      <CancelOrderModal
        show={showCancelModal}
        onClose={() => setShowCancelModal(false)}
        order={order}
        orderNo={order_no}
        navigate={navigate}
      />

      <Footer />
    </>
  );
};

export default OrderDetailPage;
